import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-la-warning',
    templateUrl: './la-warning.component.html',
    styleUrls: ['./la-warning.component.scss'],
    standalone: false
})
export class LaWarningComponent implements OnInit {
  hasCancel: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<LaWarningComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.hasCancel = this.data.hasCancel;
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
  confirm() {
    this.dialogRef.close(true);
  }
}

export interface laDialogMessage {
  errorMessages: any,
  hasCancel: boolean
}
